import '@/App.css';
import '@/i18n';
import { Routes, Route, Navigate } from 'react-router-dom';
import { LandingPage } from '@/components/LandingPage';
import { AdminDashboard } from '@/components/AdminDashboard';

const detectLang = () => {
  const nav = navigator.language || navigator.userLanguage || '';
  return nav.startsWith('zh') ? 'zh' : 'en';
};

function App() {
  return (
    <Routes>
      <Route path="/:lang" element={<LandingPage />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="*" element={<Navigate to={`/${detectLang()}`} replace />} />
    </Routes>
  );
}

export default App;
